import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'headerTitlePopover'
})
export class HeaderTitlePopoverPipe implements PipeTransform {
	public transform(headerTitle: string) {
		return headerTitle.split('|').join('<br />');
	}
}
